module.exports = "/_next/static/images/Error@2x-e708f767bfb938ac57c628db81348c38.png";